import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const TicketPieChart = ({ data }) => {
  const chartData = {
    labels: data.map(d => d.type),
    datasets: [
      {
        label: 'Sold',
        data: data.map(d => d.sold),
        backgroundColor: [
          '#8884d8',
          '#82ca9d',
          '#ffc658',
          '#ff8042',
          '#8dd1e1',
          '#a4de6c',
          '#d0ed57',
          '#fa8072',
          '#b0e0e6',
          '#dda0dd',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          font: {
            family: 'Helvetica',
            size: 14,
            weight: 'bold',
          },
        },
      },
      tooltip: {
        bodyFont: {
          family: 'Helvetica',
          size: 14,
        },
      },
    },
  };

  return <Pie data={chartData} options={options} />;
};


export default TicketPieChart